import { FC } from 'react'
import { InfoCircleOutlined, StopOutlined, WarningOutlined } from '@ant-design/icons'
import { cn } from '@/lib/utils'

const EVENT_STYLE: Record<string, { cls: string; icon: FC }> = {
  topic_changed: { cls: 'bg-blue-50 text-blue-600', icon: InfoCircleOutlined },
  flow_ended: { cls: 'bg-green-50 text-green-600', icon: StopOutlined },
  error: { cls: 'bg-red-50 text-red-600', icon: WarningOutlined },
}

/** topic_changed / flow_ended / error 的轻量内嵌 banner。 */
export const EventBanner: FC<{ eventType: string; title: string; detail?: string }> = ({
  eventType,
  title,
  detail,
}) => {
  const st = EVENT_STYLE[eventType] || EVENT_STYLE.topic_changed
  const Icon = st.icon
  return (
    // doc 105:my-0 — 条目间距由外层时间线容器 gap 统一管理
    <div className={cn('my-0 flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs', st.cls)}>
      <Icon />
      <span className="font-medium">{title}</span>
      {detail && <span className="opacity-75">{detail}</span>}
    </div>
  )
}
